module.exports = __webpack_public_path__ + "static/media/Public_17.bf89088b.jpg";